module.exports = __webpack_public_path__ + "static/media/sesionesBienestar.7bae2f1d.png";